export default "__VITE_ASSET__0220af89__"